export default __webpack_public_path__ + "facebook_button.d6f88a.png";